export const PAYMENT_SUCCESS_MESSAGE_TYPE = "gunziai:payment-success";

const LEGACY_PAYMENT_SUCCESS_MESSAGE_TYPES = new Set([
  PAYMENT_SUCCESS_MESSAGE_TYPE,
  "buildingai:alipay-payment-success",
  "gunziai:alipay-payment-success",
]);

export type PaymentSource = "membership" | "recharge";

export type PaymentSuccessMessage = {
  type: string;
  status: "success";
  payFrom: PaymentSource;
  payType?: string;
  orderId?: string;
  orderNo?: string;
};

export function parsePaymentSuccessMessage(
  data: unknown,
  expectedPayFrom: PaymentSource,
): PaymentSuccessMessage | null {
  if (!data || typeof data !== "object") return null;

  const message = data as Partial<PaymentSuccessMessage>;
  if (!message.type || !LEGACY_PAYMENT_SUCCESS_MESSAGE_TYPES.has(message.type)) return null;
  if (message.status !== "success") return null;
  if (message.payFrom !== expectedPayFrom) return null;

  return {
    type: message.type,
    status: "success",
    payFrom: message.payFrom,
    payType: message.payType,
    orderId: message.orderId,
    orderNo: message.orderNo,
  };
}
